// extracted by mini-css-extract-plugin
export default {"group":"Group-module__[local]___EjrQt","active":"Group-module__[local]___YotTI","on":"Group-module__[local]___3XWhI","off":"Group-module__[local]___hJDuM"};